export function adminErrorMessage(error: unknown, fallback: string): string {
  const message = error instanceof Error
    ? error.message
    : typeof error === "object" && error && "message" in error && typeof error.message === "string"
      ? error.message
      : "";

  const normalized = message.toLowerCase();
  if (!message) return fallback;
  if (normalized.includes("invalid login credentials")) return "E-Mail-Adresse oder Passwort ist nicht korrekt.";
  if (normalized.includes("failed to fetch") || normalized.includes("network")) return "Die Verbindung zum Server ist fehlgeschlagen. Bitte prüfe deine Internetverbindung.";
  if (normalized.includes("row-level security") || normalized.includes("permission") || normalized.includes("not allowed")) return "Für diese Aktion fehlt deinem Konto die erforderliche Berechtigung.";
  if (normalized.includes("duplicate") || normalized.includes("unique constraint")) return "Dieser Eintrag ist bereits vorhanden.";
  return message;
}

export function missingFieldsMessage(fields: string[]): string {
  const visible = fields.slice(0, 4);
  const remaining = fields.length - visible.length;
  return `Bitte ergänzen: ${visible.join(", ")}${remaining > 0 ? ` und ${remaining} weitere` : ""}.`;
}
